<svc-comments-chat
  class="block overflow-x-hidden"
  *ngIf="!isAddMode && alertFeedKey && alertId"
  placeholder="Comentar"
  [referenceId]="alertId"
  [configTypeId]="alertFeedKey"
  [applicationId]="alertApplicationId"
  (onCommentAdded)="onCommentsChanged()"
  (onCommentRemoved)="onCommentsChanged()"
/>
